// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import { Separator } from '../../../../volcanes/atoms/separator';

import { Ticket } from './ticket';
import { Tips } from './tips';

export function PixPage(): Node {

  return (
    <div data-test-id="page-pending-payment">
      <Title>Código Pix gerado!</Title>
      <Subtitle>Falta pouco pra completar o seu pedido! Use os dados abaixo para pagar:</Subtitle>
      <Ticket />
      <Separator pattern="dashed" direction="vertical" size={5.5} />
      <Tips />
    </div>
  );
}

const Title = styled.p `
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 26px;
  color: #2397d4;
  font-family: Gilroy, "Open Sans", "OpenSans", Arial, "Helvetica Neue", Helvetica, sans-serif;
  margin-bottom: 5px;
`;

const Subtitle = styled.p `
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: rgba(51, 51, 51, 0.8);
  font-family: "Open Sans", "OpenSans", Arial, "Helvetica Neue", Helvetica, sans-serif;
  margin-bottom: 15px;
`;
